import type { ComponentClass, FC } from 'react';
import React from 'react';
import { createStore, createHook, createContainer, createSubscriber } from 'react-sweet-state';

export type SearchSessionStateType = {
	/**
	 * Search ID attached to to page viewed events
	 */
	searchSessionId?: string | null;
};

type SearchSessionActions = {
	setSearchSessionId: (
		searchSessionId?: string | null,
	) => ({ setState }: { setState: any }) => void;
};

const actions: SearchSessionActions = {
	setSearchSessionId:
		(searchSessionId) =>
		({ setState }) => {
			setState({ searchSessionId: searchSessionId });
		},
};

const SearchSessionStore = createStore<SearchSessionStateType, SearchSessionActions>({
	initialState: {
		searchSessionId: undefined,
	},
	actions,
	name: 'SearchSessionStore',
});

export const SearchSessionStateContainer = createContainer(SearchSessionStore, {
	onInit:
		() =>
		({ setState }, searchSessionState: SearchSessionStateType) => {
			setState(searchSessionState);
		},
	onUpdate:
		() =>
		({ setState }, searchSessionState: SearchSessionStateType) => {
			setState(searchSessionState);
		},
});

export const useSearchSessionId = createHook(SearchSessionStore, {
	selector: (state) => state.searchSessionId,
});

export const SearchSessionSubscriber = createSubscriber(SearchSessionStore);

export function withSearchSession<P, SearchSessionStateType>(WrappedComponent: ComponentClass<P>) {
	const SearchSessionComponent: FC<P & SearchSessionStateType> = (props: P) => (
		<SearchSessionSubscriber>
			{(searchSessionState) => (
				<WrappedComponent {...props} searchSessionState={searchSessionState} />
			)}
		</SearchSessionSubscriber>
	);
	SearchSessionComponent.displayName = `withSearchSession(${
		WrappedComponent.displayName || WrappedComponent.name
	})`;
	return SearchSessionComponent;
}
